import * as Yup from 'yup';

const YEAR_REGEX = /(19|20)\d{2}/;
const MONTH_REGEX = /(01|02|03|04|05|06|07|08|09|10|11|12)/;
const DAY_REGEX =
  /(01|02|03|04|05|06|07|08|09|10|11|12|13|14|15|16|17|18|19|20|21|22|23|24|25|26|27|28|29|30|31)/;

function normalize(name) {
  return (name || '').trim().toLowerCase().replace(/\s+/g, ' ');
}

function schema() {
  return Yup.object().shape({
    id: Yup.string().nullable(true),
    accountId: Yup.string().nullable(true),
    firstName: Yup.string().required('first name is required'),
    lastName: Yup.string()
      .required('last name is required')
      .test(
        'unique-patient-name',
        'A patient with this name already exists on this account',
        function testUniquePatientName(lastName) {
          const { firstName } = this.parent;
          if (!(firstName && lastName)) {
            return true;
          }

          const { existingPatients = [], currentPatientId = null } =
            this.options.context || {};

          const normalizedFirst = normalize(firstName);
          const normalizedLast = normalize(lastName);

          return !existingPatients.some(
            (p) =>
              p.id !== currentPatientId &&
              normalize(p.firstName) === normalizedFirst &&
              normalize(p.lastName) === normalizedLast,
          );
        },
      ),
    birthDay: Yup.string()
      .required('day of birth is required')
      .matches(DAY_REGEX, 'day must be between 01 and 31'),
    birthMonth: Yup.string()
      .required('birth month is required')
      .matches(MONTH_REGEX, 'month must be between 01 and 12'),
    birthYear: Yup.string()
      .required('birth year is required')
      .matches(YEAR_REGEX, 'year must be between 1900 and 2099'),
  });
}

export default schema;
